import { render, staticRenderFns } from "./sharinFormation.vue?vue&type=template&id=53fe7385&scoped=true"
import script from "./sharinFormation.vue?vue&type=script&lang=js"
export * from "./sharinFormation.vue?vue&type=script&lang=js"
import style0 from "./sharinFormation.vue?vue&type=style&index=0&id=53fe7385&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe7385",
  null
  
)

export default component.exports